import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import { defineNuxtPlugin } from '#imports'

gsap.registerPlugin(ScrollTrigger)

export default defineNuxtPlugin({
  parallel: true,
  setup (nuxtApp) {
    // console.log('[NUXT] 22.scrolltrigger.client.js')

    ScrollTrigger.config({
      limitCallbacks: true,
      ignoreMobileResize: true
    })
    nuxtApp.bus.scrollTrigger = ScrollTrigger

    nuxtApp.bus.on('scrolltrigger:refresh', ev => { ScrollTrigger.refresh(ev) })
    nuxtApp.bus.emit('scrolltrigger:init')
  }
})
